import { render } from "./BatchwiseTraineeSummary.vue?vue&type=template&id=532e5868&ts=true"
import script from "./BatchwiseTraineeSummary.vue?vue&type=script&lang=ts"
export * from "./BatchwiseTraineeSummary.vue?vue&type=script&lang=ts"

import exportComponent from "C:\\Users\\iflam\\OneDrive\\নথিসমূহ\\tms-next\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__